import React from 'react'
import { styled } from '@mui/material'
import { TestIds } from '../../../testIds'
import Typography from '../../../components/Typography'

const ListContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
})

interface ProductListProps<T> {
  items: T[]
  renderListItem: (item: T) => React.ReactElement
}

const ProductList = <T,>({ items, renderListItem }: ProductListProps<T>) => {
  const noFilterResult = (
    <Typography variant='body1' data-testid={TestIds.feat.product.list.noProductsByFilters} mb={2}>
      There are no products matching your search. Try adjusting your filters to broaden your search.
    </Typography>
  )

  return (
    <ListContainer>
      {items.length === 0 && noFilterResult}
      {items.map((item) => renderListItem(item))}
    </ListContainer>
  )
}

export default ProductList
